var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: _vm.$t("lbtxq"),
        visible: _vm.showVisible,
        width: "600px",
      },
    },
    [
      _c(
        "el-form",
        { ref: "user", attrs: { "label-width": "100px", model: _vm.pram } },
        [
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("ljdz"), prop: "link" } },
            [
              _c("el-input", {
                attrs: { placeholder: _vm.$t("qsrljdz") },
                model: {
                  value: _vm.pram.link,
                  callback: function ($$v) {
                    _vm.$set(_vm.pram, "link", $$v)
                  },
                  expression: "pram.link",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("isShowText"), prop: "status" } },
            [
              _c(
                "el-radio-group",
                {
                  model: {
                    value: _vm.pram.status,
                    callback: function ($$v) {
                      _vm.$set(_vm.pram, "status", $$v)
                    },
                    expression: "pram.status",
                  },
                },
                [
                  _c("el-radio", { attrs: { label: 0 } }, [
                    _vm._v(_vm._s(_vm.$t("fou"))),
                  ]),
                  _vm._v(" "),
                  _c("el-radio", { attrs: { label: 1 } }, [
                    _vm._v(_vm._s(_vm.$t("shi"))),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("sctp"), prop: "value" } },
            [
              _c(
                "div",
                { staticClass: "acea-row upLoadPicBox row-middle" },
                [
                  _c(
                    "el-upload",
                    {
                      staticClass: "upload-demo",
                      attrs: {
                        action: "",
                        "http-request": _vm.handleUploadForm,
                        headers: _vm.myHeaders,
                        "show-file-list": false,
                      },
                    },
                    [
                      _vm.pram.value
                        ? _c("div", { staticClass: "pictrue" }, [
                            _c("img", {
                              attrs: { src: _vm.setUrl(_vm.pram.value) },
                            }),
                          ])
                        : _c("div", { staticClass: "upLoad" }, [
                            _c("i", {
                              staticClass: "el-icon-camera cameraIconfont",
                            }),
                          ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c("p", { staticClass: "upload-warning" }, [
                    _vm._v(
                      " \n                " +
                        _vm._s(_vm.$t("sctpWarning")) +
                        "\n              "
                    ),
                  ]),
                ],
                1
              ),
            ]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            {
              on: {
                click: function ($event) {
                  return _vm.resetForm("user")
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("calcelText")))]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              attrs: { type: "primary" },
              on: {
                click: function ($event) {
                  return _vm.submitForm("formValidate")
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("trueText")))]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }